import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'test-questions-item',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      display: 'block',
      // marginBottom: theme.spacing(2),
      padding: theme.spacing(2, 6.75),
    },
    result: {},
    correct: {},
    wrong: {},
    highlight: {
      backgroundColor: alpha(theme.palette.error.light, 0.15),
    },
    question: {
      position: 'relative',
      margin: theme.spacing(0, 0, 2),
      ...theme.typography.subtitle2,
      '& span': {
        position: 'absolute',
        right: '100%',
        transform: `translateX(${theme.spacing(-1)})`,
      },
      '&$questionFocused': {
        color: 'inherit',
      },
    },
    questionFocused: {},
    options: {},
    striped: {
      '& $option': {
        '&:nth-child(even)': {
          backgroundColor: '#F7F7FE',
        },
      },
    },
    option: {
      padding: theme.spacing(1),
      margin: 0,
      '$options & $disabled': {
        color: 'inherit',
      },
    },
    radio: {},
    checked: {},
    disabled: {},
    isCorrect: {
      '$result &$option $radio': {
        color: theme.palette.success.light,
      },
    },
    isWrong: {
      '$result &$option $radio': {
        color: theme.palette.error.light,
      },
    },
    onlyAnswers: {
      padding: 0,
    },
  }),
  options
);

export default useStyles;
